(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["story-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var GSAP_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/gsap.min.js';
    var ST_URL = 'https://cdnjs.cloudflare.com/ajax/libs/gsap/3.12.5/ScrollTrigger.min.js';

    function loadScript(src) {
      return new Promise(function (resolve, reject) {
        var existing = document.querySelector('script[src="' + src + '"]');
        if (existing) {
          if (existing.getAttribute('data-loaded') === 'true') return resolve();
          existing.addEventListener('load', resolve);
          existing.addEventListener('error', reject);
          return;
        }
        var s = document.createElement('script');
        s.src = src;
        s.async = true;
        s.onload = function () {
          s.setAttribute('data-loaded', 'true');
          resolve();
        };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    function ensureGsap() {
      if (window.gsap && window.ScrollTrigger) return Promise.resolve();
      return loadScript(GSAP_URL).then(function () {
        return loadScript(ST_URL);
      }).then(function () {
        window.gsap.registerPlugin(window.ScrollTrigger);
      });
    }

    var instances = {};

    function initInstance(root) {
      if (!root) return;
      var id = root.id;
      destroyInstance(id);

var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var isMobile = window.matchMedia('(max-width: 749px)').matches; // ADDED: skip pin/scrub on mobile
      if (reduceMotion || isMobile) return; // ADDED: isMobile check

      var scrollEl = root.querySelector('.story-timeline__scroll');
      var pinEl = root.querySelector('.story-timeline__pin');
      var panels = Array.prototype.slice.call(root.querySelectorAll('.story-timeline__panel'));
      if (!scrollEl || !pinEl || panels.length < 2) return;

      var gsap = window.gsap;
      var ScrollTrigger = window.ScrollTrigger;

      gsap.set(panels, { autoAlpha: 0, y: 60, scale: 0.98, filter: 'blur(0px)' });
      gsap.set(panels[0], { autoAlpha: 1, y: 0, scale: 1 });

      var tl = gsap.timeline({
        defaults: { ease: 'none' },
        scrollTrigger: {
          trigger: scrollEl,
          start: 'top top',
          end: 'bottom bottom',
          scrub: true,
          pin: pinEl,
          pinSpacing: false,
          anticipatePin: 1,
          invalidateOnRefresh: true
        }
      });

      // NOTE: Added a sequential split — out-fade completes first, then in-fade starts.
// This removes the overlapping-text feel between consecutive cards.
for (var i = 0; i < panels.length - 1; i++) {
  var outBlur = i === 0 ? 6 : 3;
  var outDuration = 0.45;   // ADDED: current panel blur+fade out duration (was 1, full overlap)
  var inDelay = 0.55;       // ADDED: next panel waits until current one is mostly gone
  var inDuration = 0.45;    // ADDED: next panel fade-in duration

  tl.to(panels[i], {
      autoAlpha: 0,
      y: -40,
      scale: 0.98,
      filter: 'blur(' + outBlur + 'px)',
      duration: outDuration
    }, i)
    .to(panels[i + 1], {
      autoAlpha: 1,
      y: 0,
      scale: 1,
      filter: 'blur(0px)',
      duration: inDuration
    }, i + inDelay); // ADDED: shifted start position — waits for out-fade to finish first
}

      instances[id] = tl.scrollTrigger;
    }

    function destroyInstance(id) {
      if (instances[id]) {
        instances[id].kill();
        delete instances[id];
      }
    }

    function initAll(context) {
      context = context || document;
      var roots = context.querySelectorAll('[data-story-timeline]');
      if (!roots.length) return;
      ensureGsap().then(function () {
        roots.forEach(initInstance);
        window.ScrollTrigger && window.ScrollTrigger.refresh();
      });
    }

    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initAll(document);
    }

    document.addEventListener('shopify:section:load', function (e) {
      initAll(e.target);
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('[data-story-timeline]');
      if (root) destroyInstance(root.id);
    });

    document.addEventListener('shopify:block:select', function () {
      window.ScrollTrigger && window.ScrollTrigger.refresh();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
